import { render, staticRenderFns } from "./ui-update-info.vue?vue&type=template&id=47369a4c&scoped=true&"
import script from "./ui-update-info.vue?vue&type=script&lang=ts&"
export * from "./ui-update-info.vue?vue&type=script&lang=ts&"
import style0 from "./ui-update-info.vue?vue&type=style&index=0&id=47369a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47369a4c",
  null
  
)

export default component.exports